module.exports = __webpack_public_path__ + "img/ot-avaxusdc_usdc.fdb0e784.png";